<template>
  <div>
    <el-row :gutter="10" class="u-mb-10">
      <el-col :xs="24" :sm="10">
        <el-select v-model="fluxoId" placeholder="Selecione o fluxo" style="width:100%"
                   @change="carregarArvore" data-test="seletor-fluxo">
          <el-option v-for="f in fluxos" :key="f.id" :value="f.id"
                     :label="f.nome + (f.publicado ? ' (publicado v' + f.versao + ')' : ' (rascunho)')"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="14" style="text-align:right">
        <el-tag v-if="profundidade" size="small" class="u-mr-5">{{ profundidade }} níveis</el-tag>
        <el-button size="small" :loading="validando" @click="validar" data-test="btn-validar">VALIDAR</el-button>
        <el-button class="u-ml-10" size="small" type="primary" :loading="publicando" @click="publicar"
                   data-test="btn-publicar">PUBLICAR</el-button>
      </el-col>
    </el-row>

    <!-- ============ validação estrutural (AV 13) ============ -->
    <el-alert v-if="problemas.length" type="error" :closable="false" show-icon
              class="u-mb-10" data-test="problemas"
              :title="problemas.length + ' problema(s) impedem a publicação'">
      <ul class="lista-problemas">
        <li v-for="(p, i) in problemas" :key="i">{{ p }}</li>
      </ul>
    </el-alert>
    <el-alert v-else-if="validado" type="success" :closable="false" show-icon class="u-mb-10"
              data-test="fluxo-valido" title="Estrutura válida — o fluxo pode ser publicado."></el-alert>

    <div v-if="carregando" class="estado" data-test="carregando"><i class="el-icon-loading"></i> carregando…</div>
    <div v-else-if="erro" class="estado erro" data-test="erro">{{ erro }}</div>

    <el-row v-else :gutter="10">
      <!-- ============ árvore (AV 13) ============ -->
      <el-col :xs="24" :sm="10">
        <c-panel title="Menus e nós" titleIcon="fas fa-sitemap">
          <el-button size="mini" type="primary" icon="el-icon-plus" class="u-mb-5"
                     @click="novoNo(null)" data-test="btn-novo-no">NÓ RAIZ</el-button>

          <el-tree :data="arvore" node-key="id" default-expand-all :expand-on-click-node="false"
                   data-test="arvore">
            <span slot-scope="{ data }" class="no-linha">
              <span :class="{ inativo: !data.ativo }">
                <b>{{ data.chave }}</b>
                <el-tag size="mini" class="u-ml-5">{{ data.tipo }}</el-tag>
              </span>
              <span class="no-acoes">
                <el-button type="text" size="mini" @click="editarNo(data)">editar</el-button>
                <el-button class="u-ml-10" type="text" size="mini" @click="abrirTextos(data)">textos</el-button>
                <el-button class="u-ml-10" type="text" size="mini" @click="novoNo(data.id)">+ filho</el-button>
                <el-button class="u-ml-10" type="text" size="mini" @click="removerNo(data)">remover</el-button>
              </span>
            </span>
          </el-tree>
        </c-panel>
      </el-col>

      <!-- ============ editor do nó ============ -->
      <el-col :xs="24" :sm="14">
        <c-panel :title="no.id ? 'Editando nó: ' + no.chave : 'Novo nó'" titleIcon="fas fa-edit">
          <el-form label-position="top" size="small">
            <el-row :gutter="8">
              <el-col :span="10">
                <el-form-item label="Chave">
                  <el-input v-model="no.chave" data-test="campo-chave"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Tipo">
                  <el-select v-model="no.tipo" style="width:100%" data-test="campo-tipo">
                    <el-option v-for="t in catalogos.tipos_no" :key="t" :label="t" :value="t"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Ativo">
                  <el-switch v-model="no.ativo"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- AV 17 / AV 18 — parâmetros e validações CONFIGURÁVEIS pela tela -->
            <template v-if="no.tipo === 'entrada'">
              <div class="secao">Parâmetro e validação</div>
              <el-row :gutter="8">
                <el-col :span="8">
                  <el-form-item label="Tipo de dado">
                    <el-select v-model="no.config.tipo_entrada" style="width:100%" data-test="campo-tipo-entrada">
                      <el-option v-for="t in catalogos.tipos_entrada" :key="t" :label="t" :value="t"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Guardar em">
                    <el-input v-model="no.config.campo" placeholder="ex: cpf"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Tentativas">
                    <el-input-number v-model="no.config.tentativas_max" :min="1" :max="10" size="mini"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="8">
                <el-col :span="6"><el-form-item label="Obrigatório">
                  <el-switch v-model="no.config.obrigatorio" data-test="campo-obrigatorio"></el-switch>
                </el-form-item></el-col>
                <el-col :span="6"><el-form-item label="Mínimo"><el-input v-model="no.config.min"></el-input></el-form-item></el-col>
                <el-col :span="6"><el-form-item label="Máximo"><el-input v-model="no.config.max"></el-input></el-form-item></el-col>
                <el-col :span="6"><el-form-item label="Regex"><el-input v-model="no.config.regex"></el-input></el-form-item></el-col>
              </el-row>
              <div class="obs">
                As validações são aplicadas <b>no servidor</b>. Estes campos configuram a regra;
                não substituem a checagem — requisição enviada por fora encontra as mesmas regras.
              </div>
            </template>

            <!-- AV 19 — ação, com a proteção declarada -->
            <template v-if="no.tipo === 'acao'">
              <div class="secao">Ação</div>
              <el-form-item label="Tipo de ação">
                <el-radio-group v-model="no.config.acao" size="mini">
                  <el-radio-button label="interna">serviço interno</el-radio-button>
                  <el-radio-button label="http">endereço HTTP</el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="no.config.acao === 'interna'" label="Serviço">
                <el-select v-model="no.config.servico" style="width:100%" data-test="campo-servico">
                  <el-option v-for="s in catalogos.acoes_internas" :key="s" :label="s" :value="s"></el-option>
                </el-select>
                <div class="obs">
                  Só serviços <b>registrados no código</b> aparecem aqui. Não é possível informar
                  classe ou método.
                </div>
              </el-form-item>

              <template v-else-if="no.config.acao === 'http'">
                <el-form-item label="URL">
                  <el-input v-model="no.config.url" placeholder="https://host-autorizado/caminho"
                            data-test="campo-url"></el-input>
                </el-form-item>
                <el-form-item label="Método">
                  <el-select v-model="no.config.metodo" style="width:120px">
                    <el-option label="GET" value="GET"></el-option>
                    <el-option label="POST" value="POST"></el-option>
                  </el-select>
                </el-form-item>
                <el-alert type="warning" :closable="false" show-icon>
                  <div slot="title">Hosts autorizados</div>
                  <div class="obs">
                    {{ catalogos.hosts_http && catalogos.hosts_http.length
                       ? catalogos.hosts_http.join(', ')
                       : 'Nenhum host configurado — nenhuma ação HTTP será executada.' }}
                    <br>O servidor recusa endereço fora da lista, esquema diferente de http/https,
                    IP privado e redirecionamento para rede interna.
                  </div>
                </el-alert>
              </template>
            </template>
          </el-form>

          <el-alert v-if="erroNo" type="error" :closable="false" show-icon class="u-mt-10"
                    data-test="erro-no" :title="erroNo"></el-alert>

          <div class="u-mt-10">
            <el-button size="small" type="primary" :loading="salvandoNo" @click="salvarNo"
                       data-test="btn-salvar-no">SALVAR NÓ</el-button>
          </div>

          <!-- transições -->
          <div v-if="no.id" class="secao u-mt-15">Opções deste nó (transições)</div>
          <table v-if="no.id" class="table table-striped" data-test="tabela-transicoes">
            <tr v-for="t in transicoesDoNo" :key="t.id">
              <td>{{ t.gatilho || '(seguir adiante)' }}</td>
              <td>→ {{ chaveDe(t.destino_no_id) }}</td>
              <td style="width:70px">
                <el-button type="text" size="mini" @click="removerTransicao(t)">remover</el-button>
              </td>
            </tr>
          </table>
          <el-row v-if="no.id" :gutter="6" class="u-mt-5">
            <el-col :span="9"><el-input v-model="nova.gatilho" size="mini" placeholder="rótulo da opção"></el-input></el-col>
            <el-col :span="9">
              <el-select v-model="nova.destino_no_id" size="mini" style="width:100%" placeholder="destino">
                <el-option v-for="n in nos" :key="n.id" :label="n.chave" :value="n.id"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-button size="mini" @click="salvarTransicao" data-test="btn-add-transicao">ADICIONAR</el-button>
            </el-col>
          </el-row>
        </c-panel>
      </el-col>
    </el-row>

    <!-- ============ textos por canal (AV 16) ============ -->
    <el-dialog :title="'Textos — ' + (noTextos ? noTextos.chave : '')" :visible.sync="dialogTextos"
               width="640px" append-to-body>
      <el-alert type="info" :closable="false" show-icon class="u-mb-10">
        <div slot="title">Um texto por canal</div>
        <div class="obs">
          O canal sem texto próprio usa o <b>padrão</b>. Alterar o texto do WhatsApp não altera
          o do site, e vice-versa.
        </div>
      </el-alert>

      <el-tabs v-model="canalAtivo" data-test="abas-canal">
        <el-tab-pane v-for="c in catalogos.canais" :key="c" :label="c" :name="c">
          <el-form label-position="top" size="small">
            <el-form-item label="Título">
              <el-input v-model="textos[c].titulo"></el-input>
            </el-form-item>
            <el-form-item label="Corpo">
              <el-input type="textarea" :rows="5" v-model="textos[c].corpo"
                        :data-test="'corpo-' + c"></el-input>
            </el-form-item>
            <el-form-item label="Rodapé">
              <el-input v-model="textos[c].rodape"></el-input>
            </el-form-item>
          </el-form>
          <el-button size="small" type="primary" :loading="salvandoTexto"
                     @click="salvarTexto(c)" :data-test="'btn-salvar-' + c">
            SALVAR TEXTO DE "{{ c }}"
          </el-button>
          <el-button class="u-ml-10" v-if="c !== 'padrao'" size="small" @click="removerTexto(c)">REMOVER</el-button>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
/**
 * FASE 5 / AV-3 — administração de fluxo (AV 13), textos por canal (AV 16), parâmetros
 * (AV 17), validações (AV 18) e ações (AV 19).
 *
 * Tudo o que o edital manda ser personalizável é editado aqui, sem tocar código.
 *
 * A validação estrutural e a validação da ação são do SERVIDOR. Esta tela exibe o resultado —
 * inclusive a recusa de URL perigosa, que é o que impede o administrador de virar vetor de
 * SSRF.
 */
import assistenteApi from '../assistenteApi'

export default {
  data () {
    return {
      api: null,
      fluxos: [],
      fluxoId: null,
      nos: [],
      transicoes: [],
      profundidade: null,
      problemas: [],
      validado: false,
      catalogos: { tipos_no: [], tipos_entrada: [], canais: [], acoes_internas: [], hosts_http: [] },
      carregando: false,
      erro: null,
      no: this.noVazio(),
      erroNo: null,
      salvandoNo: false,
      validando: false,
      publicando: false,
      nova: { gatilho: '', destino_no_id: null },
      dialogTextos: false,
      noTextos: null,
      canalAtivo: 'padrao',
      textos: { padrao: {}, whatsapp: {}, site: {} },
      salvandoTexto: false
    }
  },

  computed: {
    arvore () { return this.montar(null) },
    transicoesDoNo () {
      const id = this.no.id
      return this.transicoes.filter(function (t) { return t.no_id === id })
    }
  },

  mounted () {
    this.api = assistenteApi.criar({ axios: this.$axios, base: this.base(), auth: this.auth() })
    this.carregarCatalogos()
    this.carregarFluxos()
  },

  methods: {
    base () { return this.$store.state.config.baseUrlApi },
    auth () { return this.$store.getters.getHeaderAuth },

    textoErro (e) {
      const r = e && e.response ? e.response : null
      if (!r) return 'Falha de comunicação com o servidor.'
      if (r.data && typeof r.data.erro === 'string') return r.data.erro
      if (r.data && r.data.erro && r.data.erro.text) return r.data.erro.text
      return 'Erro ' + r.status + ' ao consultar o servidor.'
    },

    noVazio () {
      return { id: null, pai_id: null, chave: '', tipo: 'menu', ativo: true, ordem: 0, config: {} }
    },

    carregarCatalogos () {
      const self = this
      this.api.catalogos().then(function (r) { self.catalogos = r.data || self.catalogos })
        .catch(function () {})
    },

    carregarFluxos () {
      const self = this
      this.carregando = true
      this.api.fluxos().then(function (r) {
        self.fluxos = r.data || []
        self.carregando = false
        if (self.fluxos.length) { self.fluxoId = self.fluxos[0].id; self.carregarArvore() }
      }).catch(function (e) {
        self.carregando = false
        self.erro = self.textoErro(e)
      })
    },

    carregarArvore () {
      if (!this.fluxoId) return
      const self = this
      this.carregando = true
      this.erro = null

      this.api.arvore(this.fluxoId).then(function (r) {
        const d = r.data || {}
        self.nos = d.nos || []
        self.transicoes = d.transicoes || []
        self.profundidade = d.profundidade
        self.problemas = d.problemas || []
        self.validado = false
        self.carregando = false
      }).catch(function (e) {
        self.carregando = false
        self.erro = self.textoErro(e)
      })
    },

    montar (paiId) {
      const self = this
      return this.nos.filter(function (n) { return n.pai_id === paiId })
        .map(function (n) {
          return Object.assign({}, n, { children: self.montar(n.id) })
        })
    },

    chaveDe (id) {
      const n = this.nos.filter(function (x) { return x.id === id })[0]
      return n ? n.chave : '(?)'
    },

    novoNo (paiId) {
      this.no = this.noVazio()
      this.no.pai_id = paiId
      this.erroNo = null
    },

    editarNo (data) {
      this.no = {
        id: data.id, pai_id: data.pai_id, chave: data.chave, tipo: data.tipo,
        ativo: !!data.ativo, ordem: data.ordem,
        config: data.config ? (typeof data.config === 'string' ? JSON.parse(data.config) : data.config) : {}
      }
      this.erroNo = null
    },

    salvarNo () {
      if (this.salvandoNo) return
      const self = this
      this.salvandoNo = true
      this.erroNo = null

      this.api.salvarNo(this.fluxoId, this.no).then(function (r) {
        self.salvandoNo = false
        self.no.id = r.data.id
        self.carregarArvore()
        window.eventBus.$emit('alert', { msg: 'Nó salvo.', type: 'success' })
      }).catch(function (e) {
        self.salvandoNo = false
        // Aqui aparece a recusa de URL perigosa (AV 19), vinda do servidor.
        self.erroNo = self.textoErro(e)
      })
    },

    removerNo (data) {
      const self = this
      this.api.removerNo(this.fluxoId, data.id).then(function (r) {
        self.problemas = (r.data && r.data.problemas) || []
        if (self.no.id === data.id) self.no = self.noVazio()
        self.carregarArvore()
      })
    },

    salvarTransicao () {
      const self = this
      this.api.salvarTransicao(this.fluxoId, {
        no_id: this.no.id,
        destino_no_id: this.nova.destino_no_id,
        gatilho: this.nova.gatilho,
        ordem: this.transicoesDoNo.length
      }).then(function () {
        self.nova = { gatilho: '', destino_no_id: null }
        self.carregarArvore()
      })
    },

    removerTransicao (t) {
      const self = this
      this.api.removerTransicao(this.fluxoId, t.id).then(function () { self.carregarArvore() })
    },

    validar () {
      if (this.validando) return
      const self = this
      this.validando = true
      this.api.validarFluxo(this.fluxoId).then(function (r) {
        self.validando = false
        self.problemas = (r.data && r.data.problemas) || []
        self.validado = !!(r.data && r.data.valido)
      }).catch(function (e) {
        self.validando = false
        self.erro = self.textoErro(e)
      })
    },

    publicar () {
      if (this.publicando) return
      const self = this
      this.publicando = true

      this.api.publicarFluxo(this.fluxoId).then(function (r) {
        self.publicando = false
        if (r.data && r.data.erro) {
          self.problemas = r.data.problemas || []
          window.eventBus.$emit('alert', { msg: r.data.erro, type: 'error' })
          return
        }
        self.problemas = []
        self.validado = true
        window.eventBus.$emit('alert', { msg: 'Fluxo publicado na versão ' + r.data.versao + '.', type: 'success' })
        self.carregarFluxos()
      }).catch(function (e) {
        self.publicando = false
        const d = e && e.response ? e.response.data : null
        if (d && d.problemas) self.problemas = d.problemas
        window.eventBus.$emit('alert', { msg: self.textoErro(e), type: 'error' })
      })
    },

    // ------------------------------------------------------------- textos (AV 16)

    abrirTextos (data) {
      const self = this
      this.noTextos = data
      this.textos = { padrao: {}, whatsapp: {}, site: {} }

      this.api.textos(data.id).then(function (r) {
        (r.data || []).forEach(function (t) {
          self.textos[t.canal] = { titulo: t.titulo, corpo: t.corpo, rodape: t.rodape }
        })
        self.canalAtivo = 'padrao'
        self.dialogTextos = true
      })
    },

    salvarTexto (canal) {
      if (this.salvandoTexto) return
      const self = this
      this.salvandoTexto = true

      this.api.salvarTexto(this.noTextos.id, Object.assign({ canal: canal }, this.textos[canal]))
        .then(function () {
          self.salvandoTexto = false
          window.eventBus.$emit('alert', {
            msg: 'Texto de "' + canal + '" salvo. Os demais canais não foram alterados.',
            type: 'success'
          })
        }).catch(function (e) {
          self.salvandoTexto = false
          window.eventBus.$emit('alert', { msg: self.textoErro(e), type: 'error' })
        })
    },

    removerTexto (canal) {
      const self = this
      this.api.removerTexto(this.noTextos.id, canal).then(function (r) {
        if (r.data && r.data.erro) {
          window.eventBus.$emit('alert', { msg: r.data.erro, type: 'error' })
          return
        }
        self.textos[canal] = {}
      }).catch(function (e) {
        window.eventBus.$emit('alert', { msg: self.textoErro(e), type: 'error' })
      })
    }
  }
}
</script>

<style scoped>
.estado { padding: 20px; text-align: center; color: #909399; font-size: 12px; }
.estado.erro { color: #F56C6C; }
.no-linha { display: flex; justify-content: space-between; width: 100%; align-items: center; }
.no-acoes { white-space: nowrap; }
.inativo { opacity: .5; text-decoration: line-through; }
.secao { font-weight: 600; font-size: 12px; margin: 10px 0 6px; border-top: 1px solid #ebeef5; padding-top: 8px; }
.obs { font-size: 11px; color: #909399; }
.lista-problemas { margin: 4px 0 0 16px; font-size: 12px; }
</style>
